import _createClass from '@babel/runtime/helpers/esm/createClass';

/* eslint-disable */
var _require = require('lodash'),
    get = _require.get;

var Metrics = /*#__PURE__*/function () {
  function Metrics(metricsStats) {
    this._limit = get(metricsStats, 'limit', null);
    this._monthlyUsage = get(metricsStats, 'monthlyUsage', null);
  }
  /** **********************************************
   *  Getters/Setters of raw data
   * ********************************************* */


  _createClass(Metrics, [{
    key: 'limit',
    get: function get() {
      return this._limit;
    }
  }, {
    key: 'monthly',
    get: function get() {
      return this._monthlyUsage;
    }
  }]);

  return Metrics;
}();

export { Metrics as default };